module.exports = __webpack_public_path__ + "img/dlc_richworld1io.26a8bf3.png";